import React from 'react';
import styles from './Separator.module.scss';

export default function Separator({ text }) {
  return (
    <div className={styles.orContainer}>
      <div className={styles.hrContainer}>
        <hr />
      </div>
      <div className={styles.orDiv}>{text}</div>
      <div className={styles.hrContainer}>
        <hr />
      </div>
    </div>
  );
}
